import {createReducer} from '../utils';
import {SHOW_NEXT_BUTTON,HIDE_NEXT_BUTTON} from '../constants';

const initialState = {
    link: '',
    watch:'',
    label: 'Weiter',
    addText: '',
    isActive: false,
    submitDelay: 0
};

export default createReducer(initialState, {
    [SHOW_NEXT_BUTTON]: (state, payload) => {
       return Object.assign({}, state, {
            link: payload.link,
            watch:payload.watch,
            label: payload.label,
            addText: payload.addText || '',
            submitDelay: payload.submitDelay,
            isActive: true
        });
    },
    [HIDE_NEXT_BUTTON]: (state, payload) => {
       return Object.assign({}, state, initialState);
    }
});



// WEBPACK FOOTER //
// ./src/reducers/next.js